import type { CognitoConfig } from "frontend/src/components/CognitoAuth/cognitoAuth";
import config from "./config";

/**
 * Single source of truth for whether the app runs in Cognito auth mode and
 * with which configuration. Returns null when Cognito is not configured
 * (legacy Okta mode).
 */
export const getCognitoConfig = (): CognitoConfig | null => {
  const userPoolId = config.COGNITO_USER_POOL_ID();
  const clientId = config.COGNITO_CLIENT_ID();
  const domain = config.COGNITO_DOMAIN();

  if (!userPoolId && !clientId && !domain) {
    return null;
  }

  // A subset of the three keys is a deployment mistake, not a mode choice — fail loudly
  if (!userPoolId || !clientId || !domain) {
    throw new Error(
      `Cognito is partially configured (COGNITO_USER_POOL_ID=${!!userPoolId}, ` +
        `COGNITO_CLIENT_ID=${!!clientId}, COGNITO_DOMAIN=${!!domain}) — set all three or none`
    );
  }

  return {
    userPoolId,
    clientId,
    domain,
    redirectUri: `${window.location.origin}/cognito/callback`,
    region: config.COGNITO_REGION() || "us-east-1",
  };
};
